import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricCard = ({ title, value, change, changeType, icon, trend }) => {
  const isPositive = changeType === 'positive';
  const isNegative = changeType === 'negative';
  
  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6 shadow-elevation-sm hover:shadow-elevation-md transition-all duration-250">
      <div className="flex items-start justify-between mb-3 md:mb-4">
        <div className="flex-1 min-w-0">
          <p className="text-xs md:text-sm text-muted-foreground font-medium mb-1">{title}</p>
          <h3 className="text-xl md:text-2xl lg:text-3xl font-semibold text-foreground truncate">{value}</h3>
        </div>
        <div className="flex-shrink-0 ml-3 md:ml-4">
          <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-accent/10 flex items-center justify-center">
            <Icon name={icon} size={20} className="text-accent" />
          </div>
        </div>
      </div>
      
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-1.5">
          <Icon 
            name={isPositive ? 'TrendingUp' : isNegative ? 'TrendingDown' : 'Minus'} 
            size={16} 
            className={`${isPositive ? 'text-success' : isNegative ? 'text-destructive' : 'text-muted-foreground'}`}
          />
          <span className={`text-xs md:text-sm font-medium ${isPositive ? 'text-success' : isNegative ? 'text-destructive' : 'text-muted-foreground'}`}>
            {change}
          </span>
        </div>
        <span className="text-xs text-muted-foreground">vs last period</span>
      </div>
      
      {trend && (
        <div className="mt-3 md:mt-4 pt-3 md:pt-4 border-t border-border">
          <div className="flex items-center justify-between text-xs text-muted-foreground">
            <span>Trend</span>
            <span className="font-medium">{trend}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default MetricCard;